import { useParams } from "react-router-dom"

interface QuarterlyReportParams {
  communicationId: string
  reportId?: string
}

export const useQuarterlyReportParams = (): QuarterlyReportParams => {
  const { communicationId, reportId } = useParams<{
    communicationId: string
    reportId: string
  }>()

  return {
    communicationId: communicationId || "",
    reportId,
  }
}
